
import { motion } from "framer-motion";

const teamMembers = [
  { id: 1, name: "Alice Johnson", role: "CEO", image: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png" },
  { id: 2, name: "Bob Williams", role: "CTO", image: "https://img.freepik.com/premium-vector/avatar-profile-icon-flat-style-female-user-profile-vector-illustration-isolated-background-women-profile-sign-business-concept_157943-38866.jpg" },
  { id: 3, name: "Charlie Brown", role: "Lead Designer", image: "https://st3.depositphotos.com/15648834/17930/v/450/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg" },
  { id: 4, name: "David Smith", role: "Software Engineer", image: "https://img.freepik.com/free-vector/woman-with-long-brown-hair-pink-shirt_90220-2940.jpg" },
  { id: 5, name: "Merry Bond", role: "Software Engineer", image: "https://cdn1.iconfinder.com/data/icons/avatars-1-5/136/60-512.png" },
];
const Team = () => {
  return (
    <div className="team-container">
      <h2 className="team-title">Meet Our Team</h2>
      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <motion.div
            key={member.id}
            className="team-card"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <motion.img
              src={member.image}
              alt={member.name}
              className="team-img"
              whileHover={{ rotate: 5 }}
            />
            <h3 className="team-name">{member.name}</h3>
            <p className="team-role">{member.role}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Team;

